import React,{useState,useContext,useCallback,useEffect,FC} from 'react';
import {invokeKeyboard,closeKeyboard} from "../../KeyboardUtils/KeyboardHookUtils";
import axios from 'axios';
import { AppContext } from "../../../Context/Context"
import AppService from '../../../CommonUtils/AppService';
import { PropsType,FixMeLater } from './LicenseInputCompTypes';
import { Page } from '../../../CommonUtils/Enums';
import { mothershipModel } from '../../../CommonUtils/Functions';
import {useSetRecoilState,useRecoilValue} from "recoil";
import { pageNameAtom, profileDetailsAtom, registrationTokenAtom,jsonDataAtom, preferenceCardAtom,preferenceCardAtomDefaultValue, tokenAtom } from '../../../Recoil State/Atoms/PageAtoms';
import {spinnerOverlayAtom} from "../../../Recoil State/Atoms/AppAtoms";
import { modifyPreferenceCardInfo } from '../../../CommonUtils/Functions';

export const LicenseInputComp : FC <PropsType> = ({type,placeholder,initialVal,showAlertText,setShowAlertText,onLicenseKeyChange,selectedInstanceLicenseKey,setAlertText}) => {

    const profileDetailsSetter = useSetRecoilState(profileDetailsAtom);
    const registrationTokenSetter = useSetRecoilState(registrationTokenAtom);
    const pageNameSetter = useSetRecoilState(pageNameAtom);
    const spinnerOverlaySetter = useSetRecoilState(spinnerOverlayAtom);
    const jsonDataSetter = useSetRecoilState(jsonDataAtom);
    const preferenceCardSetter = useSetRecoilState(preferenceCardAtom);
    const setToken = useSetRecoilState(tokenAtom);

    const spinnerOverlayState = useRecoilValue(spinnerOverlayAtom);
    const jsonDataState = useRecoilValue(jsonDataAtom);

    const [inputVal,setInputVal]=useState(initialVal);
    const {setKeyboardVisibility}:FixMeLater=useContext(AppContext);

    useEffect(() => {
        if (onLicenseKeyChange) {
            onLicenseKeyChange(inputVal);
        }
    }, [inputVal, onLicenseKeyChange]);



    const makeInstallationPrefRequest=(responseToken:string,responseId:string)=>{

        axios.post(AppService.installationUrl,AppService.installationRequest,AppService.headerRequestFormat)
            .then((response)=>{
                setToken(responseToken);
                profileDetailsSetter(response.data);
                registrationTokenSetter({registrationKey:AppService.deviceRegistrationRequest.RegisterationKey,token:responseToken});
                preferenceCardSetter(modifyPreferenceCardInfo(preferenceCardAtomDefaultValue,response.data));
                makeMothershipAPIRequest(responseId);
                
            })
            .catch((err)=>{
                setShowAlertText(true);
                spinnerOverlaySetter({
                    displayOverlay:false,
                    displaySpinner:false,
                })
                
                setKeyboardVisibility(true);
                invokeKeyboard(); 
            })            
    }

    const  makeMothershipAPIRequest=(registeredLicenseId:string)=>{
        axios.post(AppService.mothershipUrl,AppService.mothershipRequest,AppService.headerRequestFormat)
            .then((response)=>{ 
                let updatedJsonDataValue= JSON.parse(JSON.stringify(jsonDataState));

                updatedJsonDataValue.License.Modules.push(mothershipModel(response.data.ModuleConfig[0]));
                updatedJsonDataValue.License.CdlsApiUrl=AppService.cdlsApiUrl;
                updatedJsonDataValue.License.CustomerId=response.data.CustomerId;
                updatedJsonDataValue.License.InstanceId=response.data.InstanceId;
                updatedJsonDataValue.License.RegisteredLicenseId= registeredLicenseId;
                
                jsonDataSetter(updatedJsonDataValue);
                setKeyboardVisibility(false);
                closeKeyboard(); 
                pageNameSetter(Page.InstallationPreferences);

                spinnerOverlaySetter({
                    displayOverlay:false,
                    displaySpinner:false,
                }) 
                
                 
            })
            .catch((err)=>{
                setShowAlertText(true);
                spinnerOverlaySetter({
                    displayOverlay:false,
                    displaySpinner:false,
                })
                
                setKeyboardVisibility(true);
                invokeKeyboard(); 
              
            })   
    }


          
    const enterAction = ()=>{
        const registrationKey = selectedInstanceLicenseKey || inputVal;
        AppService.deviceRegistrationRequest={...AppService.deviceRegistrationRequest,"RegisterationKey":registrationKey};
        spinnerOverlaySetter({
                displayOverlay:true,
                displaySpinner:true,
        })

        axios.post(AppService.deviceRegistrationUrl,AppService.deviceRegistrationRequest)
            .then((response)=>{               
                setShowAlertText(false);
                AppService.headerRequestFormat={...AppService.headerRequestFormat,headers:{...AppService.headerRequestFormat.headers,"Authorization":`Bearer ${response.data.token}`}};        
                makeInstallationPrefRequest(response.data.token,response.data.id);                  
            })
            .catch((error)=>{    
                setAlertText(error.response && error.response.data ? error.response.data : "Please Enter Valid License Key");           
                setShowAlertText(true);
                spinnerOverlaySetter({
                    displayOverlay:false,
                    displaySpinner:false,
                })    
                setKeyboardVisibility(true);
                invokeKeyboard();                           
            })

            
    }

    const onMessageReceivedFromChild=useCallback(async (e)=>{
        if (e.data === 'enter') {
            enterAction();
            return;
        }
        let receivedData=e.data;
        if(typeof(receivedData) === "string"){
            setInputVal(receivedData);
            if(showAlertText)setShowAlertText(false);
        }


    },[inputVal,setKeyboardVisibility,showAlertText,setShowAlertText,makeInstallationPrefRequest,makeMothershipAPIRequest]);


    const clickHandler=useCallback(()=>{
            invokeKeyboard(null,inputVal);
    },[inputVal]);


    const changeHandler=useCallback((e)=>{
        setInputVal(e.target.value);
        if(showAlertText)setShowAlertText(false);
    },[setInputVal,showAlertText,setShowAlertText]);


    const keyUpHandler=useCallback((e)=>{
        if(e.keyCode === 13){
            enterAction();
        }
    },[inputVal])

    useEffect(() => {
        window.addEventListener("message", onMessageReceivedFromChild);
        return () => {
            window.removeEventListener("message", onMessageReceivedFromChild);
        };
    },[onMessageReceivedFromChild]);


  return (
    <>
    <input type={type} placeholder={placeholder} value={inputVal} onClick={clickHandler} onChange={changeHandler} onKeyUp={keyUpHandler} disabled={spinnerOverlayState.displayOverlay}
    className={showAlertText?"invalid":""} 
    ></input>
    </>
  )
}
